<template>
  <hm-content>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
      <el-form-item label="秒杀订单" prop="secKillTimeOut">
        超过
        <el-input
          clearable
          size="small"
          type="number"
          class="mr10"
          v-model="ruleForm.secKillTimeOut"
        ></el-input
        >分，未付款订单自动关闭
      </el-form-item>
      <el-form-item label="正常订单" prop="orderTimeOut">
        超过
        <el-input
          clearable
          size="small"
          type="number"
          class="mr10"
          v-model="ruleForm.orderTimeOut"
        ></el-input
        >分，未付款订单自动关闭
      </el-form-item>
      <el-form-item label="发货" prop="deliveryTimeOut">
        超过
        <el-input
          clearable
          size="small"
          type="number"
          class="mr10"
          v-model="ruleForm.deliveryTimeOut"
        ></el-input
        >天，未收货订单自动确认收货
      </el-form-item>
      <el-form-item label="订单完成" prop="orderAfterSaleTime">
        超过
        <el-input
          clearable
          size="small"
          type="number"
          class="mr10"
          v-model="ruleForm.orderAfterSaleTime"
        ></el-input
        >天，自动结束交易不能申请售后
      </el-form-item>
      <el-form-item label="订单完成" prop="orderCompletePraise">
        超过
        <el-input
          clearable
          size="small"
          type="number"
          class="mr10"
          v-model="ruleForm.orderCompletePraise"
        ></el-input
        >天，自动5星好评
      </el-form-item>
      <el-form-item label="自提码" prop="storePickUpTimeOut">
        超过
        <el-input
            clearable
            size="small"
            type="number"
            class="mr10"
            v-model="ruleForm.storePickUpTimeOut"
        ></el-input
        >天，自提码过期
      </el-form-item>
    </el-form>
    <div class="btn-wrapper flex flex-center">
      <el-button @click="submitRuleForm('ruleForm')" size="small" type="primary"
        >保存</el-button
      >
      <el-button @click="back" size="small">返回</el-button>
    </div>
  </hm-content>
</template>

<script>
export default {
  data() {
    const patterndFunc = (rule, val, callback) => {
      if (val > 2880 || val < 1) {
        return callback(new Error("请输入1-2880之间的正整数"));
      }

      callback();
    };
    const patterndDeliveFunc = (rule, val, callback) => {
      if (val > 60 || val < 1) {
        return callback(new Error("请输入1-60之间的正整数"));
      }

      callback();
    };
    return {
      ruleForm: {
        secKillTimeOut: "",
        orderTimeOut: "",
        deliveryTimeOut: "",
        orderAfterSaleTime: "",
        orderCompletePraise: "",
        storePickUpTimeOut: "",
      },
      rules: {
        secKillTimeOut: [
          {
            required: true,
            message: "请输入时限",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: patterndFunc,
            trigger: "blur"
          }
        ],
        orderTimeOut: [
          {
            required: true,
            message: "请输入时限",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: patterndFunc,
            trigger: "blur"
          }
        ],
        deliveryTimeOut: [
          {
            required: true,
            message: "请输入时限",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: patterndDeliveFunc,
            trigger: "blur"
          }
        ],
        orderAfterSaleTime: [
          {
            required: true,
            message: "请输入时限",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: patterndDeliveFunc,
            trigger: "blur"
          }
        ],
        orderCompletePraise: [
          {
            required: true,
            message: "请输入时限",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: patterndDeliveFunc,
            trigger: "blur"
          }
        ],
        storePickUpTimeOut: [
          {
            required: true,
            message: "请输入天数",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: patterndDeliveFunc,
            trigger: "blur"
          }
        ],
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryDtails();
  },
  methods: {
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = [];
          for (let key in this.ruleForm) {
            if (key === "secKillTimeOut") {
              let obj = {
                code: key,
                name: "秒杀订单未付款订单自动关闭",
                value: this.ruleForm[key]
              };
              params.push(obj);
            } else if (key === "orderTimeOut") {
              let obj = {
                code: key,
                name: "正常订单未付款订单自动关闭",
                value: this.ruleForm[key]
              };
              params.push(obj);
            } else if (key === "deliveryTimeOut") {
              let obj = {
                code: key,
                name: "发货未收货订单自动关闭",
                value: this.ruleForm[key]
              };
              params.push(obj);
            } else if (key === "orderAfterSaleTime") {
              let obj = {
                code: key,
                name: "订单完成自动结束交易不能申请售后",
                value: this.ruleForm[key]
              };
              params.push(obj);
            } else if (key === "orderCompletePraise") {
              let obj = {
                code: key,
                name: "订单完成自动5星好评",
                value: this.ruleForm[key]
              };
              params.push(obj);
            }
            else if (key === "storePickUpTimeOut") {
              let obj = {
                code: key,
                name: "自提码",
                value: this.ruleForm[key]
              };
              params.push(obj);
            }
          }

          this.$store.dispatch("editSetting", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.queryDtails();
            }
          });
        }
      });
    },
    queryDtails() {
      this.$store.dispatch("configDetail").then(res => {
        res.result.map(v => {
          this.ruleForm[v.code] = v.value;
        });
      });
    },
    back() {
      this.$router.back(-1);
    }
  }
};
</script>
<style lang="scss" scoped></style>
